import { Avatar, Badge, Card, Icon, List, Table, Tag, Tooltip, Col, Collapse, Drawer, Layout, Row, Alert, message, Modal, notification, Popconfirm, Popover, Progress, Spin, Dropdown, Menu, Pagination, Tabs, Divider, AutoComplete, Button, Checkbox, DatePicker, Form, InputNumber, Input, Radio, Select, Slider, Switch, TimePicker, Upload, Typography } from 'antd';
import { createElement, PureComponent, createRef, Component } from 'react';
import styled from 'styled-components';
import InfiniteScroller from 'react-infinite-scroller';
import ResponsiveMedia from 'react-responsive';
import * as moment from 'moment';
import { isMobile } from 'react-device-detect';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}
/**
 * An avatar graphic
 */


var Avatar$1 =
/** @class */
function (_super) {
  __extends(Avatar$$1, _super);

  function Avatar$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Avatar$$1.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.color;
    delete newProps.variation;
    var className = this.props.color ? {
      className: 'ant-bg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '')
    } : undefined;
    return createElement(Avatar, _assign({}, className, newProps));
  };

  return Avatar$$1;
}(PureComponent);
/**
 * A badge
 */


var Badge$1 =
/** @class */
function (_super) {
  __extends(Badge$$1, _super);

  function Badge$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Badge$$1.prototype.render = function () {
    return createElement(Badge, _assign({}, this.props));
  };

  return Badge$$1;
}(PureComponent);

var StyledCard = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.padding;
  delete newProps.margin;
  delete newProps.position;
  delete newProps.bottom;
  delete newProps.top;
  delete newProps.position;
  delete newProps.color;
  delete newProps.boxShadow;
  delete newProps.width;
  delete newProps.variation;
  delete newProps.zIndex;
  return createElement(Card, _assign({
    size: "small"
  }, newProps));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n&& {\n    & > div.ant-card-body {\n      ", "\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n}\n"], ["\n&& {\n    & > div.ant-card-body {\n      ", "\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n}\n"
/**
 * A simple rectangular container
 */
])), function (props) {
  return props.padding ? 'padding: ' + props.padding + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : 'margin: 12px 0;';
}, function (props) {
  return props.boxShadow ? 'box-shadow: ' + props.boxShadow + ';' : '';
}, function (props) {
  return props.zIndex ? 'z-index: ' + props.zIndex + ';' : '1000;';
}, function (props) {
  return props.width ? 'width: ' + props.width + ';' : '';
}, function (props) {
  return (props.bordered === true || props.bordered === undefined) && props.color === 'primary' ? 'border: solid 1px #003a8c;' : '';
}, function (props) {
  return props.position ? 'position: ' + props.position + ';' : '';
}, function (props) {
  return props.top ? 'top: ' + props.top + ';' : '';
}, function (props) {
  return props.bottom ? 'bottom: ' + props.bottom + ';' : '';
}, function (props) {
  return (props.bordered === true || props.bordered === undefined) && props.color === 'primary' ? 'border-radius: 4px;' : '';
});
/**
 * A simple rectangular container
 */

var Card$1 =
/** @class */
function (_super) {
  __extends(Card$$1, _super);

  function Card$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Card$$1.prototype.render = function () {
    var color = this.props.color ? this.props.color : 'default';
    var className = 'ant-bg-' + color + (this.props.variation ? '-' + this.props.variation : '');
    return createElement(StyledCard, _assign({
      className: className
    }, this.props));
  };

  return Card$$1;
}(PureComponent);

var templateObject_1;
var StyledAntIcon = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.size;
  delete newProps.color;
  delete newProps.variation;
  delete newProps.margin;
  delete newProps.opacity;
  delete newProps.width;
  return createElement(Icon, _assign({}, newProps));
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n&& {\n  ", "\n  ", "\n    ", "\n    ", "\n  "], ["\n&& {\n  ", "\n  ", "\n    ", "\n    ", "\n  "])), function (props) {
  return props.size ? 'font-size: ' + props.size + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.opacity ? 'opacity: ' + props.opacity + ';' : '';
}, function (props) {
  return props.width ? 'text-align: center; width: ' + props.width + ';' : '';
});
var StyledFontAwesomeIcon = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.size;
  delete newProps.color;
  delete newProps.variation;
  delete newProps.type;
  delete newProps.margin;
  delete newProps.opacity;
  delete newProps.width;
  return createElement("i", _assign({}, newProps));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n&& {\n  ", "\n  ", "\n  ", "\n  ", "\n}\n"], ["\n&& {\n  ", "\n  ", "\n  ", "\n  ", "\n}\n"
/**
 * A graphic icon
 */
])), function (props) {
  return props.size ? 'font-size: ' + props.size + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.opacity ? 'opacity: ' + props.opacity + ';' : '';
}, function (props) {
  return props.width ? 'text-align: center; width: ' + props.width + ';' : '';
});
/**
 * A graphic icon
 */

var Icon$1 =
/** @class */
function (_super) {
  __extends(Icon$$1, _super);

  function Icon$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Icon$$1.prototype.render = function () {
    if (this.props.type && this.props.type.startsWith("fa-")) {
      var style = this.props.type.indexOf(" ") > 0 ? "" : " fa";
      var className = this.props.type + style + (this.props.color ? ' ant-fg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '') : '');
      return createElement(StyledFontAwesomeIcon, _assign({
        className: className
      }, this.props));
    } else {
      return createElement(StyledAntIcon, _assign({}, this.props));
    }
  };

  return Icon$$1;
}(PureComponent);

var templateObject_1$1, templateObject_2;
var StyledList = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.headerColor;
  delete newProps.onLoadItemData;
  delete newProps.renderItem;
  delete newProps.hasMore;
  return createElement(List, _assign({
    renderItem: props.renderItem ? props.renderItem : ""
  }, newProps));
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n&& {\n    & div.ant-list-header {\n      ", "\n    ", "\n    }\n  }\n"], ["\n&& {\n    & div.ant-list-header {\n      ", "\n    ", "\n    }\n  }\n"
/**
 * A list of items
 */
])), function (props) {
  return props.headerColor === 'primary' ? 'background-color: #397bbe;' : '';
}, function (props) {
  return props.headerColor === 'primary' ? 'color: #ffffff;' : '';
});
/**
 * A list of items
 */

var List$1 =
/** @class */
function (_super) {
  __extends(List$$1, _super);

  function List$$1(props) {
    return _super.call(this, props) || this;
  }

  List$$1.prototype.render = function () {
    if (this.props.onLoadItemData) {
      return createElement(InfiniteScroller, {
        loadMore: this.props.onLoadItemData,
        useWindow: false,
        hasMore: this.props.hasMore,
        threshold: 500
      }, createElement(StyledList, _assign({}, this.props)));
    } else {
      return createElement(StyledList, _assign({}, this.props));
    }
  };

  return List$$1;
}(PureComponent);

var templateObject_1$2;
/**
 * An item within a list.
 */

var ListItem =
/** @class */
function (_super) {
  __extends(ListItem, _super);

  function ListItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListItem.prototype.render = function () {
    return createElement(List.Item, _assign({}, this.props));
  };

  return ListItem;
}(PureComponent);

var ScreenSizesEnum;

(function (ScreenSizesEnum) {
  ScreenSizesEnum[ScreenSizesEnum["SMALL"] = 576] = "SMALL";
  ScreenSizesEnum[ScreenSizesEnum["MEDIUM"] = 768] = "MEDIUM";
  ScreenSizesEnum[ScreenSizesEnum["LARGE"] = 992] = "LARGE";
  ScreenSizesEnum[ScreenSizesEnum["EXTRA_LARGE"] = 1200] = "EXTRA_LARGE";
  ScreenSizesEnum[ScreenSizesEnum["EXTRA_EXTRA_LARGE"] = 1600] = "EXTRA_EXTRA_LARGE";
})(ScreenSizesEnum || (ScreenSizesEnum = {}));

function screenSizeFinder(windowSize) {
  if (windowSize >= ScreenSizesEnum.EXTRA_EXTRA_LARGE) {
    return "xxl";
  } else if (windowSize >= ScreenSizesEnum.EXTRA_LARGE) {
    return 'xl';
  } else if (windowSize >= ScreenSizesEnum.LARGE) {
    return 'lg';
  } else if (windowSize >= ScreenSizesEnum.MEDIUM) {
    return 'md';
  } else if (windowSize >= ScreenSizesEnum.SMALL) {
    return 'sm';
  } else {
    return 'xs';
  }
}

function checkSizeProps(size) {
  if (size.xs !== undefined || size.sm !== undefined || size.md !== undefined || size.lg !== undefined || size.xl !== undefined || size.xxl !== undefined) {
    return true;
  } else {
    return false;
  }
}
/**
 * A table of items
 */


var Table$1 =
/** @class */
function (_super) {
  __extends(Table$$1, _super);

  function Table$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      screenWidth: 'xxl'
    };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  Table$$1.prototype.componentDidMount = function () {
    if (this.props.columns.some(function (column) {
      return checkSizeProps(column);
    })) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  };

  Table$$1.prototype.componentWillUnmount = function () {
    if (this.props.columns.some(function (column) {
      return checkSizeProps(column);
    })) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  };

  Table$$1.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.onLoadItemData;
    delete newProps.hasMore;

    if (this.props.columns) {
      var newColumns = new Array();

      for (var _i = 0, _a = this.props.columns; _i < _a.length; _i++) {
        var column = _a[_i];

        var newColumn = _assign({}, column);

        if (column[this.state.screenWidth]) {
          var sizeProps = column[this.state.screenWidth];

          if (sizeProps.align) {
            newColumn.align = sizeProps.align;
          }

          if (sizeProps.visible !== undefined) {
            newColumn.visible = sizeProps.visible;
          }

          if (sizeProps.width) {
            newColumn.width = sizeProps.width;
          }
        }

        if (newColumn.visible === undefined || newColumn.visible === true) {
          newColumns.push(newColumn);
        }
      }

      newProps.columns = newColumns;
    }

    if (this.props.onLoadItemData) {
      return createElement(InfiniteScroller, {
        loadMore: this.props.onLoadItemData,
        useWindow: false,
        hasMore: this.props.hasMore,
        threshold: 1650
      }, createElement(Table, _assign({}, newProps)));
    } else {
      return createElement(Table, _assign({}, newProps));
    }
  };

  Table$$1.prototype.updateWindowDimensions = function () {
    this.setState({
      screenWidth: screenSizeFinder(window.innerWidth)
    });
  };

  return Table$$1;
}(PureComponent);

var StyledAntTag = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.maxWidth;
  delete newProps.color;
  return createElement(Tag, _assign({}, newProps));
})(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  && {\n    ", "\n  "], ["\n  && {\n    ", "\n  "
/**
 * Tag component for labeling and categorizing.
 */
])), function (props) {
  return props.maxWidth ? 'max-width: ' + props.maxWidth + '; ' + 'overflow: hidden; ' + 'text-overflow: ellipsis; ' + 'white-space: nowrap;' : '';
});
/**
 * Tag component for labeling and categorizing.
 */

var Tag$1 =
/** @class */
function (_super) {
  __extends(Tag$$1, _super);

  function Tag$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tag$$1.prototype.render = function () {
    var className = this.props.color ? {
      className: 'ant-bg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '')
    } : undefined;

    if (this.props.maxWidth) {
      return createElement(Tooltip, _assign({}, className, {
        title: this.props.children
      }), createElement(StyledAntTag, _assign({}, this.props)));
    } else {
      return createElement(StyledAntTag, _assign({}, className, this.props));
    }
  };

  return Tag$$1;
}(PureComponent);

var templateObject_1$3;
/**
 * A component that displays a title when mouse hovers over its content.
 */

var Tooltip$1 =
/** @class */
function (_super) {
  __extends(Tooltip$$1, _super);

  function Tooltip$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tooltip$$1.prototype.render = function () {
    return createElement(Tooltip, _assign({}, this.props));
  };

  return Tooltip$$1;
}(PureComponent);

var StyledCol = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.padding;
  delete newProps.variation;
  delete newProps.color;
  delete newProps.margin;
  delete newProps.grow;
  return createElement(Col, _assign({}, newProps));
})(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n&& {\n    ", "\n    ", "\n    ", "    \n"], ["\n&& {\n    ", "\n    ", "\n    ", "    \n"
/**
 * Column component for grid layouts.
 */
])), function (props) {
  return props.padding ? 'padding: ' + props.padding + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.grow ? 'flex-grow: ' + props.grow + ';' : '';
});
/**
 * Column component for grid layouts.
 */

var Col$1 =
/** @class */
function (_super) {
  __extends(Col$$1, _super);

  function Col$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Col$$1.prototype.render = function () {
    if (this.props.color) {
      var className = 'ant-bg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '');
      return createElement(StyledCol, _assign({
        className: className
      }, this.props));
    } else {
      return createElement(StyledCol, _assign({}, this.props));
    }
  };

  return Col$$1;
}(PureComponent);

var templateObject_1$4;
/**
 * A collapsable container
 */

var Collapse$1 =
/** @class */
function (_super) {
  __extends(Collapse$$1, _super);

  function Collapse$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Collapse$$1.prototype.render = function () {
    return createElement(Collapse, _assign({}, this.props));
  };

  return Collapse$$1;
}(PureComponent);
/**
 * A panel used inside a collapsable container
 */


var CollapsePanel =
/** @class */
function (_super) {
  __extends(CollapsePanel, _super);

  function CollapsePanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CollapsePanel.prototype.render = function () {
    return createElement(Collapse.Panel, _assign({}, this.props));
  };

  return CollapsePanel;
}(PureComponent);

var StyledGrid = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.opacity;
  delete newProps.height;
  delete newProps.padding;
  delete newProps.color;
  delete newProps.variation;
  delete newProps.width;
  delete newProps.margin;
  delete newProps.type;
  delete newProps.windowHeight;
  return createElement("div", _assign({}, newProps));
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  && {\n    ", "\n  ", "\n      ", "\n      ", "\n      ", "\n      ", "\n  }\n  "], ["\n  && {\n    ", "\n  ", "\n      ", "\n      ", "\n      ", "\n      ", "\n  }\n  "
/**
 * Container component for grid layouts.
 */
])), function (props) {
  return props.padding ? 'padding: ' + props.padding + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.type === 'flex' ? 'display: flex;  flex-direction: column;' : '';
}, function (props) {
  return props.height ? 'height: ' + (props.height === '100vh' ? props.windowHeight + 'px' : props.height) + ';' : '';
}, function (props) {
  return props.width ? 'width: ' + props.width + ';' : '';
}, function (props) {
  return props.opacity ? 'opacity: ' + props.opacity + ';' : '';
});
/**
 * Container component for grid layouts.
 */

var Grid =
/** @class */
function (_super) {
  __extends(Grid, _super);

  function Grid(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      windowHeight: window.innerHeight
    };
    _this.updateHeight = _this.updateHeight.bind(_this);
    return _this;
  }

  Grid.prototype.componentDidMount = function () {
    if (this.props.height === '100vh') {
      this.updateHeight();
      window.addEventListener('resize', this.updateHeight);
    }
  };

  Grid.prototype.componentWillUnmount = function () {
    if (this.props.height === '100vh') {
      window.removeEventListener('resize', this.updateHeight);
    }
  };

  Grid.prototype.render = function () {
    if (this.props.color) {
      var className = 'ant-bg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '');
      return createElement(StyledGrid, _assign({
        className: className
      }, this.props, {
        windowHeight: this.state.windowHeight
      }));
    } else {
      return createElement(StyledGrid, _assign({}, this.props, {
        windowHeight: this.state.windowHeight
      }));
    }
  };

  Grid.prototype.updateHeight = function () {
    this.setState({
      windowHeight: window.innerHeight
    });
  };

  return Grid;
}(PureComponent);

var templateObject_1$5;
var StyledDrawer = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.padding;
  delete newProps.margin;
  delete newProps.grow;
  delete newProps.xs;
  delete newProps.sm;
  delete newProps.md;
  delete newProps.lg;
  delete newProps.xl;
  delete newProps.xxl;
  return createElement(Drawer, _assign({}, newProps));
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n&& {\n    & .ant-drawer-body {\n    ", "\n    ", "\n    }\n}\n"], ["\n&& {\n    & .ant-drawer-body {\n    ", "\n    ", "\n    }\n}\n"
/**
 * Drawer component.
 */
])), function (props) {
  return props.padding ? 'padding: ' + props.padding + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
});
/**
 * Drawer component.
 */

var Drawer$1 =
/** @class */
function (_super) {
  __extends(Drawer$$1, _super);

  function Drawer$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  Drawer$$1.prototype.componentDidMount = function () {
    if (checkSizeProps(this.props)) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  };

  Drawer$$1.prototype.componentWillUnmount = function () {
    if (checkSizeProps(this.props)) {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  };

  Drawer$$1.prototype.render = function () {
    var displayState = this.state.width !== undefined ? this.props[screenSizeFinder(this.state.width)] : false;
    return displayState === true ? createElement(Grid, {
      children: this.props.children
    }) : createElement(StyledDrawer, _assign({}, this.props));
  };

  Drawer$$1.prototype.updateWindowDimensions = function () {
    this.setState({
      width: window.innerWidth
    });
  };

  return Drawer$$1;
}(PureComponent);

var templateObject_1$6;
/**
 * Layout component.
 */

var Layout$1 =
/** @class */
function (_super) {
  __extends(Layout$$1, _super);

  function Layout$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Layout$$1.prototype.render = function () {
    return createElement(Layout, _assign({}, this.props));
  };

  return Layout$$1;
}(PureComponent);
/**
 * Layout content component.
 */


var LayoutContent =
/** @class */
function (_super) {
  __extends(LayoutContent, _super);

  function LayoutContent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LayoutContent.prototype.render = function () {
    return createElement(Layout.Content, _assign({}, this.props));
  };

  return LayoutContent;
}(PureComponent);
/**
 * Layout footer component.
 */


var LayoutFooter =
/** @class */
function (_super) {
  __extends(LayoutFooter, _super);

  function LayoutFooter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LayoutFooter.prototype.render = function () {
    return createElement(Layout.Footer, _assign({}, this.props));
  };

  return LayoutFooter;
}(PureComponent);
/**
 * Layout header component.
 */


var LayoutHeader =
/** @class */
function (_super) {
  __extends(LayoutHeader, _super);

  function LayoutHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LayoutHeader.prototype.render = function () {
    return createElement(Layout.Header, _assign({}, this.props));
  };

  return LayoutHeader;
}(PureComponent);
/**
 * Layout side component.
 */


var LayoutSider =
/** @class */
function (_super) {
  __extends(LayoutSider, _super);

  function LayoutSider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LayoutSider.prototype.render = function () {
    return createElement(Layout.Sider, _assign({}, this.props));
  };

  return LayoutSider;
}(PureComponent);
/**
 * Media query component.
 */


var Media =
/** @class */
function (_super) {
  __extends(Media, _super);

  function Media() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Media.prototype.render = function () {
    return createElement(ResponsiveMedia, _assign({}, this.props));
  };

  Media.Desktop = function (props) {
    return createElement(Media, _assign({}, props, {
      minWidth: 992
    }));
  };

  Media.Tablet = function (props) {
    return createElement(Media, _assign({}, props, {
      minWidth: 768,
      maxWidth: 991
    }));
  };

  Media.Mobile = function (props) {
    return createElement(Media, _assign({}, props, {
      maxWidth: 767
    }));
  };

  Media.NotMobile = function (props) {
    return createElement(Media, _assign({}, props, {
      minWidth: 768
    }));
  };

  return Media;
}(PureComponent);

var StyledOverlay = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.opacity;
  delete newProps.height;
  delete newProps.color;
  delete newProps.width;
  delete newProps.variation;
  delete newProps.zIndex;
  return createElement("div", _assign({}, newProps));
})(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  && {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n      ", "\n      ", "\n    ", "\n    }\n  "], ["\n  && {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n      ", "\n      ", "\n    ", "\n    }\n  "
/**
 * Container component that overlays the current content.
 */
])), function (props) {
  return props.zIndex ? 'z-index: ' + props.zIndex + ';' : '1000;';
}, function (props) {
  return props.height ? 'height: ' + props.height + ';' : '';
}, function (props) {
  return props.opacity ? 'opacity: ' + props.opacity + ';' : '';
}, function (props) {
  return props.width ? 'width: ' + props.width + ';' : '';
});
/**
 * Container component that overlays the current content.
 */

var Overlay =
/** @class */
function (_super) {
  __extends(Overlay, _super);

  function Overlay() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Overlay.prototype.render = function () {
    var color = this.props.color ? this.props.color : 'default';
    var className = 'ant-bg-' + color + (this.props.variation ? '-' + this.props.variation : '');
    return createElement(StyledOverlay, _assign({
      className: className
    }, this.props));
  };

  return Overlay;
}(PureComponent);

var templateObject_1$7;
var StyledRow = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.wrap;
  delete newProps.type;
  delete newProps.scroll;
  delete newProps.color;
  delete newProps.margin;
  delete newProps.padding;
  delete newProps.variation;
  delete newProps.grow;
  delete newProps.shrink;

  if (props.type === 'flex') {
    newProps.type = 'flex';
  }

  return createElement(Row, _assign({}, newProps));
})(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n&& {\n    ", "\n  ", "\n    ", "    \n    ", "    \n    ", "    \n}\n"], ["\n&& {\n    ", "\n  ", "\n    ", "    \n    ", "    \n    ", "    \n}\n"
/**
 * Row component for grid layouts.
 */
])), function (props) {
  return props.padding ? 'padding: ' + props.padding + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.wrap === true ? 'flex-wrap: nowrap;' : '';
}, function (props) {
  return props.grow ? 'flex-grow: ' + props.grow + ';' : '';
}, function (props) {
  return props.shrink ? 'flex-shrink: ' + props.shrink + ';' : '';
});
/**
 * Row component for grid layouts.
 */

var Row$1 =
/** @class */
function (_super) {
  __extends(Row$$1, _super);

  function Row$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Row$$1.prototype.render = function () {
    var className;
    var classes = '';

    if (this.props.scroll !== undefined) {
      if (this.props.scroll === 'vertical' || this.props.scroll === 'both') {
        classes = classes + 'ant-scroll-vertical ';
      }

      if (this.props.scroll === 'horizontal' || this.props.scroll === 'both') {
        classes = classes + 'ant-scroll-horizontal ';
      }
    }

    if (this.props.color !== undefined) {
      classes = classes + 'ant-bg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '');
    }

    if (classes !== '') {
      className = {
        className: classes
      };
    }

    return createElement(StyledRow, _assign({}, className, this.props));
  };

  return Row$$1;
}(PureComponent);

var templateObject_1$8;
var StyledImage = styled.img(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    && {\n        height: 147px;\n        z-index: 5000;\n        position: relative;\n        margin-top: 16px;\n        margin-bottom: -16px;\n    }\n    "], ["\n    && {\n        height: 147px;\n        z-index: 5000;\n        position: relative;\n        margin-top: 16px;\n        margin-bottom: -16px;\n    }\n    "])));
var StyledGrid$1 = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    && {\n        z-index: 1;\n        position: relative;  \n        background-color: rgba(9, 109, 217, 0.1);\n        height: 147px\n    }\n    "], ["\n    && {\n        z-index: 1;\n        position: relative;  \n        background-color: rgba(9, 109, 217, 0.1);\n        height: 147px\n    }\n    "
/**
 * Used to present an image overlaying a background that can extend responsively.
 */
])));
/**
 * Used to present an image overlaying a background that can extend responsively.
 */

var Illustration =
/** @class */
function (_super) {
  __extends(Illustration, _super);

  function Illustration() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Illustration.prototype.render = function () {
    return createElement(StyledGrid$1, null, createElement(Row$1, {
      type: "flex",
      justify: "center"
    }, createElement(Col$1, null, createElement(StyledImage, {
      src: this.props.src
    }))));
  };

  return Illustration;
}(PureComponent);

var templateObject_1$9, templateObject_2$1;
/**
 * An Image
 */

var Image =
/** @class */
function (_super) {
  __extends(Image, _super);

  function Image() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Image.prototype.render = function () {
    return createElement("img", _assign({}, this.props));
  };

  return Image;
}(PureComponent);
/**
 * An alert component for entering a number.
 */


var Alert$1 =
/** @class */
function (_super) {
  __extends(Alert$$1, _super);

  function Alert$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Alert$$1.prototype.render = function () {
    return createElement(Alert, _assign({}, this.props));
  };

  return Alert$$1;
}(PureComponent);
/**
 * Message component.
 */


var Message =
/** @class */
function () {
  function Message() {}

  Message.success = function (props) {
    message.success(props);
  };

  Message.error = function (props) {
    message.error(props);
  };

  Message.info = function (props) {
    message.info(props);
  };

  Message.warning = function (props) {
    message.warning(props);
  };

  Message.loading = function (props) {
    message.loading(props);
  };

  Message.warn = function (props) {
    message.warn(props);
  };

  Message.destroy = function () {
    message.destroy();
  };

  return Message;
}();
/**
 * A modal dialog.
 */


var StyledModal = styled(Modal)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n&& {\n    .ant-modal-body {\n        padding: 16px;\n    }\n}\n"], ["\n&& {\n    .ant-modal-body {\n        padding: 16px;\n    }\n}\n"])));

var Modal$1 =
/** @class */
function (_super) {
  __extends(Modal$$1, _super);

  function Modal$$1(props) {
    return _super.call(this, props) || this;
  }

  Modal$$1.prototype.render = function () {
    return createElement(StyledModal, _assign({}, this.props));
  };

  Modal$$1.confirm = Modal.confirm;
  Modal$$1.warning = Modal.warning;
  Modal$$1.error = Modal.error;
  Modal$$1.info = Modal.info;
  Modal$$1.success = Modal.success;
  Modal$$1.warn = Modal.warn;
  return Modal$$1;
}(PureComponent);

var templateObject_1$a;
/**
 * Notification component.
 */

var Notification =
/** @class */
function () {
  function Notification() {}

  Notification.open = function (props) {
    notification.open(props);
  };

  Notification.success = function (props) {
    notification.success(props);
  };

  Notification.error = function (props) {
    notification.error(props);
  };

  Notification.info = function (props) {
    notification.info(props);
  };

  Notification.warning = function (props) {
    notification.warning(props);
  };

  Notification.warn = function (props) {
    notification.warn(props);
  };

  Notification.close = function () {
    notification.close("Notification Closed");
  };

  Notification.destroy = function () {
    notification.destroy();
  };

  return Notification;
}();
/**
 * PopConfirm component.
 */


var PopConfirm =
/** @class */
function (_super) {
  __extends(PopConfirm, _super);

  function PopConfirm() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PopConfirm.prototype.render = function () {
    return createElement(Popconfirm, _assign({}, this.props));
  };

  return PopConfirm;
}(PureComponent);
/**
 * Popover component.
 */


var Popover$1 =
/** @class */
function (_super) {
  __extends(Popover$$1, _super);

  function Popover$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Popover$$1.prototype.render = function () {
    return createElement(Popover, _assign({}, this.props));
  };

  return Popover$$1;
}(PureComponent);
/**
 * Progress component.
 */


var Progress$1 =
/** @class */
function (_super) {
  __extends(Progress$$1, _super);

  function Progress$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Progress$$1.prototype.render = function () {
    return createElement(Progress, _assign({}, this.props));
  };

  return Progress$$1;
}(PureComponent);
/**
 * Spin component.
 */


var Spin$1 =
/** @class */
function (_super) {
  __extends(Spin$$1, _super);

  function Spin$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Spin$$1.prototype.render = function () {
    return createElement(Spin, _assign({}, this.props));
  };

  return Spin$$1;
}(PureComponent);
/**
 * A dropdown list.
 */


var Dropdown$1 =
/** @class */
function (_super) {
  __extends(Dropdown$$1, _super);

  function Dropdown$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Dropdown$$1.prototype.render = function () {
    return createElement(Dropdown, _assign({}, this.props));
  };

  return Dropdown$$1;
}(PureComponent);
/**
 * A hypertext link.
 */


var Link =
/** @class */
function (_super) {
  __extends(Link, _super);

  function Link() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Link.prototype.render = function () {
    var href = this.props.href ? {
      href: this.props.href
    } : null;
    var onClick = this.props.onClick ? {
      onClick: this.props.onClick
    } : null;
    var classNames = 'ant-dropdown-link' + (href === null ? ' ant-dropdown-trigger' : '');
    return this.props.icon ? createElement("div", _assign({}, onClick), createElement("a", _assign({
      className: classNames
    }, href), createElement(Row$1, {
      type: 'flex'
    }, this.props.iconPosition !== 'right' && createElement(Col$1, {
      margin: '0 8px 0 0'
    }, createElement(Icon$1, {
      type: this.props.icon
    })), createElement(Col$1, null, this.props.children), this.props.iconPosition === 'right' && createElement(Col$1, {
      margin: '0 0 0 8px'
    }, createElement(Icon$1, {
      type: this.props.icon
    }))))) : createElement("a", _assign({
      className: classNames
    }, onClick, href), this.props.children);
  };

  return Link;
}(PureComponent);

var StyledMenu = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.margin;
  return createElement(Menu, _assign({}, newProps));
})(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n&& {\n    ", "\n}\n"], ["\n&& {\n    ", "\n}\n"
/**
 * A menu.
 */
])), function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
});
/**
 * A menu.
 */

var Menu$1 =
/** @class */
function (_super) {
  __extends(Menu$$1, _super);

  function Menu$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Menu$$1.prototype.render = function () {
    return createElement(StyledMenu, _assign({}, this.props));
  };

  return Menu$$1;
}(PureComponent);

var templateObject_1$b;
/**
 * Menu divider component.
 */

var MenuDivider =
/** @class */
function (_super) {
  __extends(MenuDivider, _super);

  function MenuDivider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MenuDivider.prototype.render = function () {
    return createElement(Menu.Divider, _assign({}, this.props));
  };

  return MenuDivider;
}(PureComponent);
/**
 * Menu item component.
 */


var MenuItem =
/** @class */
function (_super) {
  __extends(MenuItem, _super);

  function MenuItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MenuItem.prototype.render = function () {
    return createElement(Menu.Item, _assign({}, this.props));
  };

  return MenuItem;
}(PureComponent);
/**
 * Handles navigation of a long list of items using paging.
 */


var Pagination$1 =
/** @class */
function (_super) {
  __extends(Pagination$$1, _super);

  function Pagination$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Pagination$$1.prototype.render = function () {
    return createElement(Pagination, _assign({}, this.props));
  };

  return Pagination$$1;
}(PureComponent);
/**
 * Menu item component.
 */


var SubMenu =
/** @class */
function (_super) {
  __extends(SubMenu, _super);

  function SubMenu() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SubMenu.prototype.render = function () {
    return createElement(Menu.SubMenu, _assign({}, this.props));
  };

  return SubMenu;
}(PureComponent);
/**
 * A tab within the Tabs component.
 */


var TabPane =
/** @class */
function (_super) {
  __extends(TabPane, _super);

  function TabPane() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TabPane.prototype.render = function () {
    return createElement(Tabs.TabPane, _assign({}, this.props));
  };

  return TabPane;
}(PureComponent);
/**
 * A set of tabs.
 */


var Tabs$1 =
/** @class */
function (_super) {
  __extends(Tabs$$1, _super);

  function Tabs$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tabs$$1.prototype.render = function () {
    return createElement(Tabs, _assign({}, this.props));
  };

  return Tabs$$1;
}(PureComponent);

var StyledDivider = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.margin;
  return createElement(Divider, _assign({}, newProps));
})(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n&& {\n    ", "\n}\n"], ["\n&& {\n    ", "\n}\n"
/**
 * A divider.
 */
])), function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : 'margin: 24px 0;';
});
/**
 * A divider.
 */

var Divider$1 =
/** @class */
function (_super) {
  __extends(Divider$$1, _super);

  function Divider$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Divider$$1.prototype.render = function () {
    return createElement(StyledDivider, _assign({}, this.props));
  };

  return Divider$$1;
}(PureComponent);

var templateObject_1$c;
/**
 * An input component with autocomplete functionality
 */

var AutoComplete$1 =
/** @class */
function (_super) {
  __extends(AutoComplete$$1, _super);

  function AutoComplete$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AutoComplete$$1.prototype.render = function () {
    return createElement(AutoComplete, _assign({}, this.props));
  };

  return AutoComplete$$1;
}(PureComponent);

var StyledAntButton = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.borderless;
  delete newProps.xs;
  delete newProps.sm;
  delete newProps.md;
  delete newProps.lg;
  delete newProps.xl;
  delete newProps.xxl;

  if (props.size === 'x-large') {
    delete newProps.size;
  }

  return createElement(Button, _assign({}, newProps));
})(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n && {\n    ", "\n    ", "\n     }\n "], ["\n && {\n    ", "\n    ", "\n     }\n "])), function (props) {
  return props.borderless ? 'border: none; box-shadow: none;' : '';
}, function (props) {
  return props.size === 'x-large' ? 'height: 56px;' : '';
});
/**
 * To trigger an operation.
 */

var Button$1 =
/** @class */
function (_super) {
  __extends(Button$$1, _super);

  function Button$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  Button$$1.prototype.componentDidMount = function () {
    if (checkSizeProps(this.props)) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  };

  Button$$1.prototype.componentWillUnmount = function () {
    if (checkSizeProps(this.props)) {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  };

  Button$$1.prototype.render = function () {
    var displayState = this.state.width !== undefined ? this.props[screenSizeFinder(this.state.width)] : true;
    var visible = displayState === undefined ? true : displayState;
    return visible ? createElement(StyledAntButton, _assign({}, this.props)) : null;
  };

  Button$$1.prototype.updateWindowDimensions = function () {
    this.setState({
      width: window.innerWidth
    });
  };

  return Button$$1;
}(PureComponent);

var templateObject_1$d;
var StyledGroup = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.block;
  return createElement(Button.Group, _assign({}, newProps));
})(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n&& {\n    ", "\n}\n"], ["\n&& {\n    ", "\n}\n"
/**
 * Button grouping component.
 */
])), function (props) {
  return props.block === true ? 'width: 100%;' + 'display: flex;' + '& > button {' + '   display: flex;' + '   flex-grow: 1;' + '   justify-content: center;' + '}' : '';
});
/**
 * Button grouping component.
 */

var ButtonGroup =
/** @class */
function (_super) {
  __extends(ButtonGroup, _super);

  function ButtonGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ButtonGroup.prototype.render = function () {
    return createElement(StyledGroup, _assign({}, this.props));
  };

  return ButtonGroup;
}(PureComponent);

var templateObject_1$e;
/**
 * An input component for controlling a boolean flag.
 */

var Checkbox$1 =
/** @class */
function (_super) {
  __extends(Checkbox$$1, _super);

  function Checkbox$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Checkbox$$1.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.onChange;
    return createElement(Checkbox, _assign({
      onChange: this.handleChange
    }, newProps));
  };

  Checkbox$$1.prototype.handleChange = function (e) {
    if (this.props.onChange) {
      this.props.onChange(e.nativeEvent);
    }
  };

  return Checkbox$$1;
}(PureComponent);

var NativeDatePicker = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.format;
  delete newProps.size;
  delete newProps.children;
  delete newProps.disabled;
  delete newProps.value;
  var value = props.value ? props.value.format("YYYY-MM-DD") : undefined;
  return createElement("span", {
    className: "ant-calendar-picker"
  }, createElement("div", null, createElement("input", _assign({
    type: "date",
    value: value
  }, newProps)), createElement(Icon, {
    type: "calendar",
    className: 'ant-calendar-picker-icon'
  })));
})(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    min-width: 14em;\n"], ["\n    min-width: 14em;\n"])));
/**
 * An input component for entering a date.
 */

var DatePicker$1 =
/** @class */
function (_super) {
  __extends(DatePicker$$1, _super);

  function DatePicker$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  DatePicker$$1.prototype.render = function () {
    if (isMobile) {
      var newProps = _assign({}, this.props);

      var className = 'ant-calendar-picker-input ant-input';

      if (this.props.disabled && this.props.disabled === true) {
        className += ' ant-input-disabled';
      }

      if (this.props.size === 'large') {
        className += ' ant-input-lg';
      } else if (this.props.size === 'small') {
        className += ' ant-input-sm';
      }

      return createElement(NativeDatePicker, _assign({
        className: className
      }, newProps, {
        onChange: this.handleChange
      }));
    } else {
      return createElement(DatePicker, _assign({}, this.props));
    }
  };

  DatePicker$$1.prototype.handleChange = function (event) {
    var stringToMoment = moment;

    if (this.props.onChange) {
      this.props.onChange(stringToMoment(event.target.value), event.target.value);
    }
  };

  return DatePicker$$1;
}(PureComponent);

var templateObject_1$f;
/**
 * Data entry form.
 */

var Form$1 =
/** @class */
function (_super) {
  __extends(Form$$1, _super);

  function Form$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Form$$1.create = function ()
  /* options?: FormCreateOption<{}> | undefined */
  {
    return Form.create();
  };

  Form$$1.prototype.render = function () {
    return createElement(Form, _assign({}, this.props));
  };

  return Form$$1;
}(PureComponent);
/**
 * Data entry form.
 */


var FormItem =
/** @class */
function (_super) {
  __extends(FormItem, _super);

  function FormItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FormItem.prototype.render = function () {
    return createElement(Form.Item, _assign({}, this.props));
  };

  return FormItem;
}(PureComponent);
/**
 * An input component for entering a number.
 */


var InputNumber$1 =
/** @class */
function (_super) {
  __extends(InputNumber$$1, _super);

  function InputNumber$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputNumber$$1.prototype.render = function () {
    if (this.props.forceKeypad && this.props.forceKeypad === true) {
      var newProps = _assign({}, this.props);

      delete newProps.forceKeypad;
      return createElement(InputNumber, _assign({
        pattern: "\\d*"
      }, newProps));
    } else {
      return createElement(InputNumber, _assign({}, this.props));
    }
  };

  return InputNumber$$1;
}(PureComponent);
/**
 * A dialog used to prompt the user to enter the score.
 */


var EnterScoreDialog =
/** @class */
function (_super) {
  __extends(EnterScoreDialog, _super);

  function EnterScoreDialog(props) {
    var _this = _super.call(this, props) || this;

    _this.handleSaveScore = _this.handleSaveScore.bind(_this);
    _this.handleDateChange = _this.handleDateChange.bind(_this);
    _this.handleScoreChange = _this.handleScoreChange.bind(_this);
    _this.handleAttemptsChange = _this.handleAttemptsChange.bind(_this);
    _this.state = {
      attempts: _this.props.defaultAttempts
    };
    return _this;
  }

  EnterScoreDialog.prototype.render = function () {
    return createElement(Modal$1, {
      visible: this.props.open,
      title: "Enter Score",
      okText: "Save",
      onOk: this.handleSaveScore,
      cancelText: "Cancel",
      onCancel: this.props.onClose,
      afterClose: this.props.onClose
    }, createElement(Form$1, null, createElement(FormItem, {
      label: this.props.scoreLabel
    }, createElement(InputNumber$1, {
      forceKeypad: true,
      placeholder: "",
      onChange: this.handleScoreChange
    })), this.renderAttemptsInput(), this.renderDateInput()));
  };

  EnterScoreDialog.prototype.renderAttemptsInput = function () {
    if (this.props.attemptsLabel) {
      return createElement(FormItem, {
        label: this.props.attemptsLabel
      }, createElement(InputNumber$1, {
        forceKeypad: true,
        placeholder: "",
        value: this.state.attempts,
        onChange: this.handleAttemptsChange
      }));
    } else {
      return null;
    }
  };

  EnterScoreDialog.prototype.renderDateInput = function () {
    if (this.props.dateLabel) {
      return createElement(FormItem, {
        label: this.props.dateLabel
      }, createElement(DatePicker$1, {
        size: "large",
        placeholder: "",
        onChange: this.handleDateChange
      }));
    } else {
      return null;
    }
  };

  EnterScoreDialog.prototype.handleAttemptsChange = function (value) {
    value >= 0 ? this.setState({
      attempts: value
    }) : this.setState({
      attempts: 0
    });
  };

  EnterScoreDialog.prototype.handleScoreChange = function (value) {
    this.setState({
      score: value
    });
  };

  EnterScoreDialog.prototype.handleDateChange = function (date, dateString) {
    this.setState({
      date: date
    });
  };

  EnterScoreDialog.prototype.handleSaveScore = function () {
    var score = this.state.score;
    var date = this.state.date;
    var attempts = this.state.attempts;
    this.props.onSaveScore(score, date, attempts);
    this.props.onClose();
  };

  return EnterScoreDialog;
}(PureComponent);
/**
 * An input component for entering a string.
 */


var Input$1 =
/** @class */
function (_super) {
  __extends(Input$$1, _super);

  function Input$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Input$$1.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.innerRef;
    return createElement(Input, _assign({}, newProps, {
      ref: this.props.innerRef
    }));
  };

  return Input$$1;
}(PureComponent);
/**
 * An input component for entering an email address.
 */


var InputEmail =
/** @class */
function (_super) {
  __extends(InputEmail, _super);

  function InputEmail() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputEmail.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.innerRef;
    return createElement(Input, _assign({
      type: "email"
    }, newProps, {
      ref: this.props.innerRef
    }));
  };

  return InputEmail;
}(PureComponent);

var AntInputGroup = Input.Group;
/**
 * An input component for searching a value.
 */

var InputGroup =
/** @class */
function (_super) {
  __extends(InputGroup, _super);

  function InputGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputGroup.prototype.render = function () {
    return createElement(AntInputGroup, _assign({}, this.props));
  };

  return InputGroup;
}(PureComponent);
/**
 * An input component for entering a phone number.
 */


var InputPhoneNumber =
/** @class */
function (_super) {
  __extends(InputPhoneNumber, _super);

  function InputPhoneNumber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputPhoneNumber.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.innerRef;
    return createElement(Input, _assign({
      type: 'tel'
    }, newProps, {
      ref: this.props.innerRef
    }));
  };

  return InputPhoneNumber;
}(PureComponent);

var AntInputSearch = Input.Search;
/**
 * An input component for searching a value.
 */

var InputSearch =
/** @class */
function (_super) {
  __extends(InputSearch, _super);

  function InputSearch() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputSearch.prototype.render = function () {
    return createElement(AntInputSearch, _assign({}, this.props));
  };

  return InputSearch;
}(PureComponent);

var AntInputTextArea = Input.TextArea;
/**
 * An input component for searching a value.
 */

var InputTextArea =
/** @class */
function (_super) {
  __extends(InputTextArea, _super);

  function InputTextArea() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputTextArea.prototype.render = function () {
    return createElement(AntInputTextArea, _assign({}, this.props));
  };

  return InputTextArea;
}(PureComponent);
/**
 * Input control for picking a month.
 */


var MonthPicker =
/** @class */
function (_super) {
  __extends(MonthPicker, _super);

  function MonthPicker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MonthPicker.prototype.render = function () {
    return createElement(DatePicker.MonthPicker, _assign({}, this.props));
  };

  return MonthPicker;
}(PureComponent);
/**
 * An input component for controlling a radio.
 */


var Radio$1 =
/** @class */
function (_super) {
  __extends(Radio$$1, _super);

  function Radio$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Radio$$1.prototype.render = function () {
    return _super.prototype.render.call(this);
  };

  return Radio$$1;
}(Radio);

var AntRadioButton = Radio.Button;
/**
 * An input component for controlling a radio.
 */

var RadioButton =
/** @class */
function (_super) {
  __extends(RadioButton, _super);

  function RadioButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RadioButton.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.onChange;
    return createElement(AntRadioButton, _assign({}, newProps));
  };

  return RadioButton;
}(PureComponent);

var AntRadioGroup = Radio.Group;
/**
 * An input component for controlling a radio.
 */

var RadioGroup =
/** @class */
function (_super) {
  __extends(RadioGroup, _super);

  function RadioGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  RadioGroup.prototype.render = function () {
    var newProps = _assign({}, this.props);

    delete newProps.onChange;
    return createElement(AntRadioGroup, _assign({
      onChange: this.handleChange
    }, newProps));
  };

  RadioGroup.prototype.handleChange = function (e) {
    if (this.props.onChange) {
      this.props.onChange(e.nativeEvent);
    }
  };

  return RadioGroup;
}(PureComponent);
/**
 * A select component
 */


var Select$1 =
/** @class */
function (_super) {
  __extends(Select$$1, _super);

  function Select$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Select$$1.prototype.render = function () {
    return createElement(Select, _assign({}, this.props));
  }; // tslint:disable-next-line:member-access


  Select$$1.Option = Select.Option;
  return Select$$1;
}(PureComponent);

var Canvas = styled.canvas(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    border: 1px dashed grey;\n    margin-bottom: 9px;\n"], ["\n    border: 1px dashed grey;\n    margin-bottom: 9px;\n"])));

var Signature =
/** @class */
function (_super) {
  __extends(Signature, _super);

  function Signature(props) {
    var _this = _super.call(this, props) || this;

    _this.prevX = 0;
    _this.currX = 0;
    _this.prevY = 0;
    _this.currY = 0;

    _this.handleMouseMove = function (e) {
      if (_this.drawOn) {
        _this.prevX = _this.currX;
        _this.prevY = _this.currY;
        _this.currX = e.clientX - _this.canvas.getBoundingClientRect().left;
        _this.currY = e.clientY - _this.canvas.getBoundingClientRect().top;

        _this.ctx.beginPath();

        _this.ctx.moveTo(_this.prevX, _this.prevY);

        _this.ctx.lineTo(_this.currX, _this.currY);

        _this.ctx.strokeStyle = 'black';
        _this.ctx.lineWidth = 2;

        _this.ctx.stroke();

        _this.ctx.closePath();
      }
    };

    _this.handleTouchMove = function (e) {
      if (_this.drawOn) {
        var touch = e.touches[0];
        _this.prevX = _this.currX;
        _this.prevY = _this.currY;
        _this.currX = touch.clientX - _this.canvas.getBoundingClientRect().left;
        _this.currY = touch.clientY - _this.canvas.getBoundingClientRect().top;

        _this.ctx.beginPath();

        _this.ctx.moveTo(_this.prevX, _this.prevY);

        _this.ctx.lineTo(_this.currX, _this.currY);

        _this.ctx.strokeStyle = 'black';
        _this.ctx.lineWidth = 2;

        _this.ctx.stroke();

        _this.ctx.closePath();
      }
    };

    _this.handleMouseDown = function (e) {
      _this.prevX = _this.currX;
      _this.prevY = _this.currY;
      _this.currX = e.clientX - _this.canvas.getBoundingClientRect().left;
      _this.currY = e.clientY - _this.canvas.getBoundingClientRect().top;
      _this.drawOn = true;

      _this.ctx.beginPath();

      _this.ctx.fillStyle = 'black';

      _this.ctx.fillRect(_this.currX, _this.currY, 2, 2);

      _this.ctx.closePath();
    };

    _this.handleTouchDown = function (e) {
      var touch = e.touches[0];
      _this.prevX = _this.currX;
      _this.prevY = _this.currY;
      _this.currX = touch.clientX - _this.canvas.getBoundingClientRect().left;
      _this.currY = touch.clientY - _this.canvas.getBoundingClientRect().top;
      _this.drawOn = true;

      _this.ctx.beginPath();

      _this.ctx.fillStyle = 'black';

      _this.ctx.fillRect(_this.currX, _this.currY, 2, 2);

      _this.ctx.closePath();
    };

    _this.finishDrawing = function () {
      _this.drawOn = false;
    };

    _this.handleSave = function () {
      if (_this.state.tab !== 'canvas') {
        _this.ctx.font = "14pt cursive";

        _this.ctx.clearRect(0, 0, 300, 90);

        _this.ctx.fillText(_this.state.textSign, 10, 50);
      }

      var image = _this.canvasRef.current.toDataURL().substring(22);

      _this.props.onSave(image, true);
    };

    _this.handleTextSignChange = function (e) {
      _this.setState({
        textSign: e.target.value
      });
    };

    _this.state = {
      tab: 'canvas',
      textSign: ''
    };
    _this.canvasRef = createRef();
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleTouchDown = _this.handleTouchDown.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.finishDrawing = _this.finishDrawing.bind(_this);
    _this.setTab = _this.setTab.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleTextSignChange = _this.handleTextSignChange.bind(_this);
    return _this;
  }

  Signature.prototype.componentDidMount = function () {
    this.canvas = this.canvasRef.current;

    if (this.canvas == null) {
      throw new Error('Canvas with "sign-canvas" id must be presented in the "Signature" component');
    }

    this.ctx = this.canvasRef.current.getContext('2d');
  };

  Signature.prototype.setTab = function (key) {
    this.setState({
      tab: key
    });
  };

  Signature.prototype.render = function () {
    return createElement(Grid, null, createElement(Row$1, null, createElement(Col$1, {
      margin: '12px 12px 8px 12px'
    }, createElement(Tabs$1, {
      defaultActiveKey: "canvas",
      onTabClick: this.setTab.bind(TabPane)
    }, createElement(TabPane, {
      key: 'canvas',
      tab: 'Draw'
    }, createElement(Row$1, {
      type: 'flex',
      justify: 'center'
    }, createElement(Canvas, {
      ref: this.canvasRef,
      id: "sign-canvas",
      width: 300,
      height: 90,
      style: this.state.tab !== 'canvas' ? {
        display: 'none',
        touchAction: 'none'
      } : undefined,
      onMouseMove: this.handleMouseMove,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.finishDrawing,
      onMouseOut: this.finishDrawing,
      onTouchMove: this.handleTouchMove,
      onTouchEnd: this.finishDrawing,
      onTouchStart: this.handleTouchDown
    }), createElement(Button$1, {
      type: 'primary',
      block: true,
      onClick: this.handleSave
    }, "Submit"))), createElement(TabPane, {
      key: 'type',
      tab: 'Type'
    }, createElement(Row$1, null, createElement(Col$1, {
      margin: '0 8px 8px 8px'
    }, createElement(Input$1, {
      placeholder: 'type',
      type: "text",
      onChange: this.handleTextSignChange
    }), createElement(Col$1, {
      margin: '8px 0 0 0'
    }, createElement(Button$1, {
      type: 'primary',
      block: true,
      onClick: this.handleSave
    }, "Submit")))))))));
  };

  return Signature;
}(Component);

var templateObject_1$g;
/**
 * An input component for selecting a value within a range.
 */

var Slider$1 =
/** @class */
function (_super) {
  __extends(Slider$$1, _super);

  function Slider$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Slider$$1.prototype.render = function () {
    return createElement(Slider, _assign({}, this.props));
  };

  return Slider$$1;
}(PureComponent);
/**
 * An input component for controlling a boolean flag.
 */


var Switch$1 =
/** @class */
function (_super) {
  __extends(Switch$$1, _super);

  function Switch$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Switch$$1.prototype.render = function () {
    return createElement(Switch, _assign({}, this.props));
  };

  return Switch$$1;
}(PureComponent);

var NativeTimePicker = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.format;
  delete newProps.size;
  delete newProps.children;
  delete newProps.disabled;
  delete newProps.use12Hours;
  delete newProps.value;
  var value = props.value ? props.value.format("HH:mm") : undefined;
  return createElement("span", {
    className: "ant-time-picker"
  }, createElement("div", null, createElement("input", _assign({
    type: "time",
    value: value
  }, newProps)), createElement(Icon, {
    type: "clock-circle",
    className: 'ant-time-picker-icon'
  })));
})(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    min-width: 14em;\n"], ["\n    min-width: 14em;\n"])));
/**
 * An input component for entering time.
 */

var TimePicker$1 =
/** @class */
function (_super) {
  __extends(TimePicker$$1, _super);

  function TimePicker$$1(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  TimePicker$$1.prototype.render = function () {
    if (isMobile) {
      var newProps = _assign({}, this.props);

      delete newProps.onChange;
      var className = 'ant-calendar-time-picker-input ant-input';

      if (this.props.disabled && this.props.disabled === true) {
        className += ' ant-input-disabled';
      }

      if (this.props.size === 'large') {
        className += ' ant-input-lg';
      } else if (this.props.size === 'small') {
        className += ' ant-input-sm';
      }

      return createElement(NativeTimePicker, _assign({
        className: className
      }, newProps, {
        onChange: this.handleChange
      }));
    } else {
      return createElement(TimePicker, _assign({}, this.props));
    }
  };

  TimePicker$$1.prototype.handleChange = function (event) {
    var stringToMoment = moment;

    if (this.props.onChange) {
      this.props.onChange(stringToMoment(event.target.value, 'HH:mm'), event.target.value);
    }
  };

  return TimePicker$$1;
}(PureComponent);

var templateObject_1$h;
/**
 * An input component for uploading files.
 */

var Upload$1 =
/** @class */
function (_super) {
  __extends(Upload$$1, _super);

  function Upload$$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Upload$$1.prototype.render = function () {
    return createElement(Upload, _assign({}, this.props));
  };

  return Upload$$1;
}(PureComponent);
/**
 * Input control for picking a week.
 */


var WeekPicker =
/** @class */
function (_super) {
  __extends(WeekPicker, _super);

  function WeekPicker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WeekPicker.prototype.render = function () {
    return createElement(DatePicker.WeekPicker, _assign({}, this.props));
  };

  return WeekPicker;
}(PureComponent);

var StyledHeading = styled(function (props) {
  var newProps = _assign({}, props);

  delete newProps.margin;
  delete newProps.color;
  delete newProps.variation;
  delete newProps.maxWidth;
  delete newProps.level;
  delete newProps.weight;
  var component = props.level === 7 ? 'div' : "h" + props.level;
  var Component$$1 = component;
  return createElement(Component$$1, _assign({}, newProps), props.children);
})(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n&& {\n  ", "\n  ", "\n  ", "\n"], ["\n&& {\n  ", "\n  ", "\n  ", "\n"
/**
 * A heading.
 */
])), function (props) {
  var fontWeights = {
    regular: '400',
    medium: '500',
    bold: '700'
  };
  return props.weight ? 'font-weight: ' + fontWeights[props.weight] + ';' : '';
}, function (props) {
  return props.margin ? 'margin: ' + props.margin + ';' : '';
}, function (props) {
  return props.maxWidth ? 'max-width: ' + props.maxWidth + '; ' + 'overflow: hidden; ' + 'text-overflow: ellipsis; ' + 'white-space: nowrap;' : '';
});
/**
 * A heading.
 */

var Heading =
/** @class */
function (_super) {
  __extends(Heading, _super);

  function Heading() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Heading.prototype.render = function () {
    var className = this.props.level === 7 ? 'ant-heading-7 ' : 'ant-heading ';
    className += this.props.color ? 'ant-fg-' + this.props.color + (this.props.variation ? '-' + this.props.variation : '') : '';

    if (this.props.maxWidth) {
      return createElement(Tooltip, {
        title: this.props.children
      }, createElement(StyledHeading, _assign({
        className: className
      }, this.props), this.props.children));
    } else {
      return createElement(StyledHeading, _assign({
        className: className
      }, this.props), this.props.children);
    }
  };

  return Heading;
}(PureComponent);

var templateObject_1$i;

var Paragraph =
/** @class */
function (_super) {
  __extends(Paragraph, _super);

  function Paragraph() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Paragraph.prototype.render = function () {
    return createElement(Typography.Paragraph, _assign({}, this.props), this.props.children);
  };

  return Paragraph;
}(PureComponent);

var Title =
/** @class */
function (_super) {
  __extends(Title, _super);

  function Title() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Title.prototype.render = function () {
    return createElement(Typography.Title, _assign({}, this.props), this.props.children);
  };

  return Title;
}(PureComponent);
/**
 * A level 6 heading.
 */


var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Text.prototype.render = function () {
    return createElement(Typography.Text, _assign({}, this.props), this.props.children);
  };

  return Text;
}(PureComponent);

export { Avatar$1 as Avatar, Badge$1 as Badge, Card$1 as Card, Icon$1 as Icon, List$1 as List, ListItem, Table$1 as Table, Tag$1 as Tag, Tooltip$1 as Tooltip, Col$1 as Col, Collapse$1 as Collapse, CollapsePanel, Drawer$1 as Drawer, Grid, Layout$1 as Layout, LayoutContent, LayoutFooter, LayoutHeader, LayoutSider, Media, Overlay, Row$1 as Row, Illustration, Image, Alert$1 as Alert, Message, Modal$1 as Modal, Notification, PopConfirm, Popover$1 as Popover, Progress$1 as Progress, Spin$1 as Spin, Dropdown$1 as Dropdown, Link, Menu$1 as Menu, MenuDivider, MenuItem, Pagination$1 as Pagination, SubMenu, TabPane, Tabs$1 as Tabs, Divider$1 as Divider, AutoComplete$1 as AutoComplete, Button$1 as Button, ButtonGroup, Checkbox$1 as Checkbox, DatePicker$1 as DatePicker, EnterScoreDialog, Form$1 as Form, FormItem, Input$1 as Input, InputEmail, InputGroup, InputNumber$1 as InputNumber, InputPhoneNumber, InputSearch, InputTextArea, MonthPicker, Radio$1 as Radio, RadioButton, RadioGroup, Select$1 as Select, Signature, Slider$1 as Slider, Switch$1 as Switch, TimePicker$1 as TimePicker, Upload$1 as Upload, WeekPicker, Heading, Paragraph, Title, Text };